export default __webpack_public_path__ + "static/media/374.14893174.jpg";